import { localeSpecificGroup } from 'utils/override';

export const modernLayoutTranslations = localeSpecificGroup({
  supported_payment_network: {
    _: 'Supported Payment Network',
    'zh-hk': '信用卡類別',
    'zh-tw': '信用卡類別',
  },
  supported_payment_type: {
    _: 'Supported Payment Type',
    'zh-hk': '支援付款功能',
    'zh-tw': '支援付款功能',
  },
});
